<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <printer-form :info="info"/>
      </div>
    </div>
  </section>
</template>

<script>
import printerForm from './Temp/PrinterFormTemp.vue'

export default {
  name: 'Tables',
  data () {
    return {
      info: {}
    }
  },
  components: {
    'printer-form': printerForm
  },
  methods: {
    getPrinterInfo () {
      var self = this
      var url = '/printer/' + this.$route.params.printer_id
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.info = response.data.printer
        }
      })
    }
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    }
  },
  created () {
    this.getPrinterInfo()
  }
}
</script>



// WEBPACK FOOTER //
// UpPrinter.vue?59df9dc4